<template>
  <v-dialog :value="value" @click:outside="close" :width="defaultDialogWidth" persistent>
    <v-card>
      <div class="py-4 px-5">
        <h5 class="title">Отменить кредит</h5>
      </div>
      <v-card-text>
        <validation-observer ref="formObs" v-slot="{handleSubmit}">
          <form @submit.prevent="handleSubmit(() => $emit('submit', comment))">
            <custom-text-textarea
              name="Коментария"
              rules="required"
              placeholder="Оставьте комментарии почему хотите отклонить..."
              v-model="comment"
            ></custom-text-textarea>
            <v-btn type="submit" color="error" width="100%">Отменить кредит</v-btn>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import {defaultDialogWidth} from "@/utils/constants";

  export default {
    name: 'reject-credit-dialog',
    props: {
      value: {
        type: Boolean
      },
    },
    data() {
      return {
        comment: '',
        defaultDialogWidth
      }
    },
    methods: {
      close() {
        this.$emit('input', false)
        this.comment = ''
        this.$refs.formObs.reset()
      }
    }
  }
</script>